import React, { useEffect, useState } from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function UrgencyBar() {
  // Start at 4 minutes 52 seconds (292 seconds)
  const [timeLeft, setTimeLeft] = useState(292);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `00:0${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  return <div className="fixed top-0 left-0 w-full z-50 bg-gradient-to-r from-red-950 via-red-900 to-red-950 border-b border-red-700 animate-pulse-slow shadow-[0_0_15px_rgba(220,38,38,0.3)]" data-id="element-102">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 text-center" data-id="element-103">
        <div className="flex items-center gap-2 text-red-100 text-sm md:text-base font-medium" data-id="element-104">
          <AlertTriangleIcon className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-105" />
          <p data-id="element-106">
            <strong className="text-white" data-id="element-107">ADVERTENCIA DE SEGURIDAD:</strong> El
            precio de lanzamiento de $47 termina cuando el contador llegue a
            cero. Una vez finalizado, el "Sentinel Bundle" volverá a su precio
            original de $197.
          </p>
        </div>
        <div className="flex-shrink-0 font-mono text-lg md:text-xl font-bold text-cyan-accent text-glow-cyan tracking-wider bg-black/40 px-3 py-1 rounded border border-cyan-accent/30" data-id="element-108">
          [{formattedTime}]
        </div>
      </div>
    </div>;
}